module.exports = __webpack_public_path__ + "static/media/varkenshaasje.b6a7ff85.jpg";